import { render, staticRenderFns } from "./ChallengeRecordsList.vue?vue&type=template&id=ff69a1da"
import script from "./ChallengeRecordsList.vue?vue&type=script&lang=js"
export * from "./ChallengeRecordsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports